'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.set = set;
exports.update = update;
exports.setErrors = setErrors;
exports.clearErrors = clearErrors;
exports.clearPrice = clearPrice;
exports.clear = clear;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET = 'search/SET'; // search state contains all the search params for API calls

var UPDATE = 'search/UPDATE';
var SET_ERROR = 'search/SET_ERROR';
var CLEAR_ERROR = 'search/CLEAR_ERROR';
var CLEAR_PRICE = 'search/CLEAR_PRICE';
var CLEAR = 'search/CLEAR';

var initialState = {
  offset: '0',
  limit: '20',
  currency: 'JPY',
  stay: '',
  // stay: '[2016-12-02T00:00:00+09:00,2016-12-03T23:59:59+09:00]',
  rooms: '1',
  adults: '',
  children: '',
  age: '',
  bed: '',
  country: '',
  subdivision: '',
  city: '',
  spot: '',
  plan: '',
  room: '',
  rate: '',
  latlng: '',
  radius: '',
  price: '',
  meals: '',
  orderBy: '',
  hotelFacility: '',
  roomFacility: '',
  // errors: [
  //   {
  //     code: 'param_required',
  //     field: 'subdivision'
  //   },
  //   {
  //     code: 'param_invalid',
  //     field: 'subdivision',
  //     message: ''
  //   }
  // ]
  errors: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    // overwrites the search state base on the initialState
    case SET:
      return (0, _extends3.default)({}, initialState, action.conditions, { errors: [], currency: state.currency });
    // update the search state, only overwrites the specified values
    case UPDATE:
      return (0, _extends3.default)({}, state, action.conditions, { errors: [] });
    case SET_ERROR:
      return (0, _extends3.default)({}, state, { errors: action.errors });
    case CLEAR_ERROR:
      return (0, _extends3.default)({}, state, { errors: [] });
    case CLEAR_PRICE:
      return (0, _extends3.default)({}, state, { price: '' });
    case CLEAR:
      return (0, _extends3.default)({}, initialState, { currency: state.currency });
    default:
      return state;
  }
}

// filter out unneccessary props
function filterState(conditions) {
  var values = (0, _lodash2.default)(conditions).omit(_lodash2.default.isUndefined).omit(_lodash2.default.isNull).value();
  var result = {};
  (0, _keys2.default)(initialState).forEach(function (key) {
    if (values[key]) {
      result[key] = values[key];
    }
  });
  // XXX: the min price cannot be 0
  if (result.price) {
    var matched = result.price.match(/\[(\d+\.?\d+),(\d+\.?\d+)\]/);
    if (matched && Number(matched[1]) === 0) {
      result.price = '[1,' + matched[2] + ']';
    }
  }
  return result;
}

function set() {
  var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var newCondition = filterState(conditions);
  return {
    type: SET,
    conditions: newCondition
  };
}

function update() {
  var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var newCondition = filterState(conditions);
  return {
    type: UPDATE,
    conditions: newCondition
  };
}

function setErrors(errors) {
  return {
    type: SET_ERROR,
    errors: errors
  };
}

function clearErrors() {
  return {
    type: CLEAR_ERROR
  };
}

function clearPrice() {
  return {
    type: CLEAR_PRICE
  };
}

function clear() {
  return {
    type: CLEAR
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/modules/search.js
// module id = 66
// module chunks = 0